import { StatusBar, Style } from "@capacitor/status-bar";
import { getPlatform } from "./platform";

/**
 * Update status bar style based on theme (iOS and Android)
 */
export const updateStatusBarStyle = (theme: "light" | "dark", bgColor?: string): void => {
  const platform = getPlatform();
  if (platform !== "android" && platform !== "ios") return;

  StatusBar.setStyle({
    style: theme === "dark" ? Style.Dark : Style.Light,
  }).catch(() => {});

  if (platform === "android") {
    const color = bgColor || (theme === "dark" ? "#000000" : "#FFFFFF");
    StatusBar.setBackgroundColor({ color }).catch(() => {});
  }
};

let _themeColorOverride: string | null = null;

/**
 * Replace the theme-color meta tag with a new element.
 */
const replaceThemeColorMeta = (color: string): void => {
  if (typeof document === "undefined") return;
  const existing = document.querySelector('meta[name="theme-color"]');
  if (existing) existing.remove();
  const meta = document.createElement("meta");
  meta.setAttribute("name", "theme-color");
  meta.setAttribute("content", color);
  document.head.appendChild(meta);
};

/**
 * Set a page-level theme-color override.
 */
export const setMetaThemeColor = (color: string): void => {
  _themeColorOverride = color;
  replaceThemeColorMeta(color);
  if (typeof document !== "undefined") {
    document.documentElement.style.backgroundColor = color;
  }
};

/**
 * Clear the page-level override and restore the theme default.
 */
export const resetMetaThemeColor = (): void => {
  _themeColorOverride = null;
  replaceThemeColorMeta("#000000");
  if (typeof document !== "undefined") {
    document.documentElement.style.backgroundColor = "#000000";
  }
};
